
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryFollowupGrid extends Serenity.EntityGrid<EnquiryFollowupRow, any> {
        protected getColumnsKey() { return EnquiryFollowupColumns.columnsKey; }
        protected getDialogType() { return EnquiryFollowupDialog; }
        protected getIdProperty() { return EnquiryFollowupRow.idProperty; }
        protected getInsertPermission() { return EnquiryFollowupRow.insertPermission; }
        protected getLocalTextPrefix() { return EnquiryFollowupRow.localTextPrefix; }
        protected getService() { return EnquiryFollowupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {
            let filters = super.getQuickFilters();

            Q.first(filters, x => x.field == EnquiryFollowupRow.Fields.FollowUpDate).init = w => {
                var today = new Date();
                // w is a reference to the editor for this quick filter widget
                // here we cast it to DateEditor, and set its value as date.
                // note that in Javascript, months are 0 based, so date below
                // is actually 2016-05-01
                (w as Serenity.DateEditor).valueAsDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2);

                // setting start date was simple. but this quick filter is actually
                // a combination of two date editors. to get reference to second one,
                // need to find its next sibling element by its class
                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
            };

            return filters;
        }
    }
}